import { DatePipe, NgClass } from "@angular/common";
import { Component, computed, inject, input, signal, Signal, WritableSignal } from "@angular/core";
import { AppraisalVerificationComponent } from "../appraisal-verification/appraisal-verification.component";
import { ThousandizePipe } from "ev-core";
import { BaseListComponent, EvGridTableModule, ITableHeader, ITableLayoutModel, SortUtil } from "ev-grid-table";
import { DefaultConverterPipe } from "src/app/shared/pipes/defaultconverter.pipe";
import { AppraisalReportApprovalStatus, AppraisalStatus, IValuationHistory, ValueHistoryType } from "src/models/estate/valuation-history.model";
import { environment } from "src/environments/environment";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";
import { take } from "rxjs";
import { EstateDataService } from "src/services/estate-data.service";
import { SavedEstimateDetailsComponent } from "./detail-views/saved-estimate-details/saved-estimate-details.component";
import { DropdownTriggerForDirective, EvDropdownBaseComponent } from "ev-dropdown-base";
import { AppraisalDenialReasonDetails } from "src/models/estate/appraisal.model";
import { AppraisalValues } from "../appraisal-verification/appraisal-verification.component";
import { AppraisalService } from "src/services/appraisal-data.service";
import { EvCdkTooltipComponent } from "ev-cdk-tooltip";
import { OverlayModule } from "@angular/cdk/overlay";
import { AppraisalComponent } from "./detail-views/appraisal/appraisal.component";
import { IValuationHistoryAppraisalDetails } from "src/models/estate/appraisal-details.model";

@Component({
    selector: "valuation-history-residential",
    templateUrl: "./valuation-history-residential.component.html",
    styleUrl: "./valuation-history-residential.component.scss",
    imports: [EvGridTableModule, DefaultConverterPipe, ThousandizePipe, DatePipe, NgClass, EvLogoLoaderComponent, SavedEstimateDetailsComponent, EvDropdownBaseComponent, DropdownTriggerForDirective, AppraisalVerificationComponent, OverlayModule, EvCdkTooltipComponent, AppraisalComponent],
})
export class ValuationHistoryResidentialComponent extends BaseListComponent<IValuationHistory> {
    private estateDataService = inject(EstateDataService);
    private appraisalService = inject(AppraisalService);
    isRowExpanded(expanded: boolean, data: IValuationHistoryRow): void {
        if (expanded) {
            this.fetchDetails(data);
        }
        data.expanded = expanded;
    }
    getAppraisalValueReport(valuation: IValuationHistoryRow) {
        alert("Ikke implementert ennå");
    }
    getAppraisalReport(rowData: IValuationHistoryRow) {
        alert("Ikke implementert ennå");

    }
    getAppraisalsUrl(rowData: IValuationHistoryRow) {
        alert("Ikke implementert ennå");
    }

    isOpenableAppraisal(rowData: IValuationHistoryRow): boolean {
        return this.hasAppraisalRole() && rowData.valueHistoryTypeEnum === ValueHistoryType.ETakstMegler;
    }
    
    isLoadingDetails = signal<Record<string, boolean>>({});
    customerUnitDetails = signal<Record<string, any>>({});
    valuationHistory = input.required<IValuationHistory[]>();
    selectedFilters = input.required<ValueHistoryType[]>();

    evWebUrl = signal<string>(environment.evwebUrl);

    authService = inject(EvAuthorizationService);

    protected readonly valueHistoryType = ValueHistoryType;
    protected readonly appraisalStatus = AppraisalStatus;
    protected readonly appraisalApprovalStatus = AppraisalReportApprovalStatus;

    protected hasAppraisalRole = toSignal(this.authService.hasPermission(EVServiceType.Appraisal_Realtor));
    protected hasSearchAppraisalRole = toSignal(this.authService.hasPermission(EVServiceType.Appraisal_Bank));
    protected hasEvEstimateRole = toSignal(this.authService.hasPermission(EVServiceType.EvWeb_Estimate2021)); //i gammel løsning kan man også ha 2014, men den er det bare interne som har.

    originalData = computed(() => {
        const history = this.valuationHistory();
        if (!history) {
            return [];
        }
        let index = 1;
        return (
            history.map((item) => {
                if (item.valueHistoryTypeEnum === ValueHistoryType.LagretEstimat) {
                    return {
                        ...item,
                        index: index++,
                        estimateUrl: this.getEstimateReportUrl(item.detailId!),
                    };
                }
                const hasAdUrls = !!item?.adUrls === true;
                return {
                    ...item,
                    index: index++,
                    hasHjemAd: hasAdUrls && item.adUrls.some((a) => a.source === 1 && a.url !== null),
                    hasFinnAd: hasAdUrls && item.adUrls.some((a) => a.source === 0 && a.url !== null),
                    hjemUrl: hasAdUrls && item.adUrls.find((a) => a.source === 1)?.url,
                    finnUrl: hasAdUrls && item.adUrls.find((a) => a.source === 0) ? `${this.evWebUrl()}/Resource/Prospect?saleId=${item.detailId}` : null,
                    tooltipVisible: false,
                    expanded: false,
                };
            }) || []
        );
    });


    showAppraisalValuationDialog: boolean = false;
    appraisalDeniedReasons = signal<AppraisalDenialReasonDetails[]>([]);
    private appraisalDeniedReasonsLoaded = false;
    appraisalValues: AppraisalValues = null;

    override tableData: Signal<any[]> = computed(() => {
        const config = this.sortConfig();
        const rows = this.numberOfRowsConfig().rowsToShow;
        const data = [...(this.filteredRows() || [])];

        if (data.length === 0) {
            return [];
        }

        const sortedUnits = SortUtil.simpleSortObj(data, config.sortOption);

        return sortedUnits.slice(0, rows);
    });

    filteredRowsCount = computed(() => {
        return this.tableData().length;
    });
    protected filteredRows = computed(() => {
        return this.originalData().filter((item) => this.selectedFilters().includes(item.valueHistoryTypeEnum));
    });
    constructor() {
        super();
    }
    
    protected openProspectReport(detailId: number) {
        alert("Ikke implementert ennå");
        // const url = `https://www.eiendomsverdi.no/Prospect/Report/${detailId}`;
        // window.open(url, "_blank");
    }
    
    protected createDisplayTemplate(): ITableLayoutModel {
        return {
            breakPoints: [
                {
                    gridAreas: '"info date priceAssumptionValue value commonDebt totalValue squareMeterPrice status links"',
                    gridColumns: "36px 234px 100px 120px 80px 100px 100px auto 210px",
                },
            ],
        };
    }

    protected override createHeaders(): ITableHeader[] {
        return [
            {
                name: "",
                prop: "info",
                desc: false,
                type: "text",
                isSortable: false,
            },
            {
                name: "Dato",
                prop: "date",
                desc: false,
                type: "date",
                isSortable: true,
            },
            {
                name: "Prisant",
                prop: "priceAssumptionValue",
                desc: false,
                type: "number",
                isSortable: true,
                textAlignment: "right",
            },
            { name: "Pris", prop: "value", desc: false, type: "number", isSortable: true, textAlignment: "right" },
            {
                name: "F gjeld",
                prop: "commonDebt",
                desc: false,
                type: "number",
                isSortable: true,
                textAlignment: "right",
            },
            {
                name: "Pris ink fg",
                prop: "totalValue",
                desc: false,
                type: "number",
                isSortable: true,
                textAlignment: "right",
            },
            {
                name: "m² pris",
                prop: "squareMeterPrice",
                desc: false,
                type: "number",
                isSortable: true,
                textAlignment: "right",
            },
            {
                name: "",
                prop: "status",
                desc: false,
                type: "text",
                isSortable: false,
            },
            {
                name: "",
                prop: "links",
                desc: false,
                type: "text",
                isSortable: false,
            },
        ];
    }
    private getEstimateReportUrl(detailId?: Number) {
        if (environment.evwebUrl.includes("Home")) {
            const baseurl = environment.evwebUrl.replace("Home", "Report");
            const url = `${baseurl}/GetStoredEstimate?id=${detailId}`;
            return url;
        }
        return null;
    }
    protected fetchDetails(row: IValuationHistoryRow): void {
        if (row.valueHistoryTypeEnum === ValueHistoryType.LagretEstimat) {
            this.isLoadingDetails.set({ ...this.isLoadingDetails(), [row.index]: true });
            this.estateDataService
                .getStoredEstimateDetails(row.detailId!)
                .pipe(take(1))
                .subscribe((details) => {
                    this.customerUnitDetails.set({ ...this.customerUnitDetails(), [row.index]: details });
                    this.isLoadingDetails.set({ ...this.isLoadingDetails(), [row.index]: false });
                });
        } else if (row.valueHistoryTypeEnum === ValueHistoryType.ETakstMegler || row.valueHistoryTypeEnum === ValueHistoryType.ETakst) {
            this.isLoadingDetails.set({ ...this.isLoadingDetails(), [row.index]: true });
            this.appraisalService
                .getValuationAppraisalDetails(row.detailId)
                .pipe(take(1))
                .subscribe((details) => {
                    this.customerUnitDetails.set({ ...this.customerUnitDetails(), [row.index]: details });
                    this.isLoadingDetails.set({ ...this.isLoadingDetails(), [row.index]: false });
                    row.appraisalDetails = signal(details);
                });
        }
    }

    protected showAppraisalDialog(refId: string = "", reportId: number = 0, valueHistoryType: ValueHistoryType = 3) {
        this.showAppraisalValuationDialog = true;
        this.appraisalValues = new AppraisalValues(refId, reportId, valueHistoryType);

        if (!this.appraisalDeniedReasonsLoaded) {
            this.appraisalDeniedReasonsLoaded = true;
            this.appraisalService
                .getAppraisalDenialReasons(true)
                .pipe(take(1))
                .subscribe((reasons) => this.appraisalDeniedReasons.set(reasons));
        }
    }

    protected closeAppraisalDialog() {
        this.showAppraisalValuationDialog = false;
    }
}

export interface IValuationHistoryRow extends IValuationHistory {
    index: number;
    hasFinnAd: boolean;
    hasHjemAd: boolean;
    finnUrl: string;
    hjemUrl: string;
    hasAdText: boolean;
    estimateUrl?: string;
    tooltipVisible: boolean;
    expanded: boolean;
    appraisalDetails?: WritableSignal<IValuationHistoryAppraisalDetails>;
}
